import { Checkbox } from '@/components/ui/checkbox';
import {
  AI_CHINA_WORDING,
  CONSENT_CHANNELS,
  MARKETING_WORDING,
  SERVICE_WORDING,
  TRANSFER_WORDING,
  type ConsentChannel,
  type ConsentChoices,
} from '@/lib/consents';

/**
 * The three answers, as plain checkboxes: reminders about the person's own
 * journey (per channel), offers and news (per channel, never pre-ticked by
 * this component), and processing outside their country. Controlled: the
 * caller decides when to save.
 */
export function ConsentChoicesFields({ value, onChange, disabled = false, idPrefix = 'consent' }: {
  value: ConsentChoices;
  onChange: (next: ConsentChoices) => void;
  disabled?: boolean;
  idPrefix?: string;
}) {
  const setChannel = (group: 'serviceReminders' | 'marketing', channel: ConsentChannel, on: boolean) =>
    onChange({ ...value, [group]: { ...value[group], [channel]: on } });

  const channelRow = (group: 'serviceReminders' | 'marketing') => (
    <div className="mt-1.5 flex flex-wrap gap-x-4 gap-y-1.5">
      {CONSENT_CHANNELS.map(({ key, label }) => {
        const id = `${idPrefix}-${group}-${key}`;
        return (
          <div key={key} className="flex items-center gap-1.5">
            <Checkbox id={id} checked={value[group][key]} disabled={disabled}
              onCheckedChange={(c) => setChannel(group, key, c === true)} />
            <label htmlFor={id} className="text-xs">{label}</label>
          </div>
        );
      })}
    </div>
  );

  return (
    <div className="space-y-3">
      <fieldset>
        <legend className="text-xs font-medium">{SERVICE_WORDING}</legend>
        {channelRow('serviceReminders')}
        <p className="mt-1 text-xs text-muted-foreground">Never in the evening or at night. Reply STOP on WhatsApp or SMS to stop them.</p>
      </fieldset>
      <fieldset>
        <legend className="text-xs font-medium">{MARKETING_WORDING}</legend>
        {channelRow('marketing')}
      </fieldset>
      <div className="flex items-start gap-2">
        <Checkbox id={`${idPrefix}-transfer`} checked={value.transferAbroad} disabled={disabled}
          onCheckedChange={(c) => onChange({ ...value, transferAbroad: c === true })} />
        <label htmlFor={`${idPrefix}-transfer`} className="text-xs leading-5">
          I agree: {TRANSFER_WORDING}{' '}
          <a href="/privacy" target="_blank" rel="noreferrer" className="underline hover:text-primary">More in the Privacy Policy</a>
        </label>
      </div>
      <div className="flex items-start gap-2">
        <Checkbox id={`${idPrefix}-ai-china`} checked={value.transferAbroad && value.aiChina}
          disabled={disabled || !value.transferAbroad}
          onCheckedChange={(c) => onChange({ ...value, aiChina: c === true })} />
        <label htmlFor={`${idPrefix}-ai-china`} className="text-xs leading-5">
          I also agree: {AI_CHINA_WORDING}
        </label>
      </div>
    </div>
  );
}
